// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// require("es6-promise").polyfill();
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import AppLayout from './layouts/AppLayout';
import AppHeader from './layouts/AppHeader';
import AppFooter from './layouts/AppFooter';
import AppMain from './layouts/AppMain';
import BetterScroll from './components/BetterScroll';
import EmptyView from './components/EmptyView';
import TabBar from './components/TabBar'


import api from "./axios/api";
//console.log(aps);
Vue.use(api);

// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);

// ajax请求 参考：https://github.com/imcvampire/vue-axios
import axios from './axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload,{
	preLoad:1.3,
	error:'',
	loading:'',
	attempt:1
})
// import Vconsole from 'vconsole';
// new Vconsole();
// import {baseUrl} from '../config/CONSTANTS';
//
// axios.defaults.baseURL = baseUrl;
// axios.defaults.withCredentials = true;

// const instance = axios.create({
// 	baseURL: baseUrl,
// 	headers: {'content-type': 'foobar'}
// });

// UI-框架 参考：https://github.com/ElemeFE/mint-ui
import Mint from 'mint-ui'
Vue.use(Mint)
// import 'mint-ui/lib/style.css'
import { InfiniteScroll } from 'mint-ui';

Vue.use(InfiniteScroll);

import {version} from "./config/CONSTANTS";

// 引入全局flex.css  参考：http://cnodejs.org/topic/56d1148d9f876b7e6658579e
import './assets/css/main.scss';



const localVersion = localStorage.version || '';
if(version !== localVersion) {
	// localStorage.clear();
	sessionStorage.clear();
	localStorage.version = version;
}

const app = {
	loadVue: function() {
		Vue.config.productionTip = false;
		router.afterEach((to,form,next) =>{
			window.scrollTo(0,0)
		})
		// 取消 Vue 所有的日志与警告。
		// Vue.config.silent = true;
		/* eslint-disable no-new */
		new Vue({
			el: '#app',
			router,
			store,
			components: { App },
			template: '<App/>'
		});
	},
	loadComponents: function() {
		Vue.component('app-layout', AppLayout);
		Vue.component('app-header', AppHeader);
		Vue.component('app-footer', AppFooter);
		Vue.component('app-main', AppMain);
		Vue.component('better-scroll', BetterScroll);
		Vue.component('empty-view', EmptyView);
		Vue.component('tab-bar', TabBar);
	},
	/**
	 * 客户端判断`
	 */
	clientJudge() {
		let dev = window.navigator.userAgent.toLocaleLowerCase().match(/MicroMessenger/i);
		if (dev && dev[0] === 'micromessenger') {
			store.commit('CLIENT', 0);
		} else {
			store.commit('CLIENT', 1);
		}
	},
	init: function() {
		this.loadVue();
		this.loadComponents();
		this.clientJudge();
	}
};

app.init();




// WEBPACK FOOTER //
// ./src/main.js